import {Signal} from 'typed-signals';

type Props = {
  margin: string;
  ratio: number;
};

export type ViewportObserverEventType =
  | 'above'
  | 'above-pre'
  | 'below'
  | 'below-pre'
  | 'up'
  | 'down';

export class ViewportObserver {
  private readonly margin: string;
  private observer: IntersectionObserver;
  private target: HTMLElement;
  public onChange = new Signal<(type: ViewportObserverEventType) => void>();

  constructor({margin = '0', ratio = 0.1}: Props) {
    this.margin = margin;
    this.target = document.documentElement;

    const threshold = [0, ratio];
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          // FIXME: Componentは、domのreplace後にunmountを実行しているので、parentから削除されrootBoundsがnullになる。ブラウザの仕様変更かも？
          if (!entry.rootBounds) return;
          const isAbove = entry.boundingClientRect.top > entry.rootBounds.top;
          const isBelow = !isAbove;
          const isDown = isAbove;
          const isUp = isBelow;
          if (isDown) {
            if (entry.intersectionRatio > ratio) {
              this.onChange.emit('below');
            } else {
              this.onChange.emit('below-pre');
            }
          }
          if (isUp) {
            if (entry.intersectionRatio > ratio) {
              this.onChange.emit('above');
            } else {
              this.onChange.emit('above-pre');
            }
          }

          if (entry.intersectionRatio > ratio) {
            this.onChange.emit('down');
          } else {
            this.onChange.emit('up');
          }
        }
      },
      {
        rootMargin: this.margin,
        threshold,
      },
    );
  }

  observe(element?: HTMLElement | null) {
    element && this.observer.observe(element);
  }

  unobserve(element?: HTMLElement | null) {
    element && this.observer.unobserve(element);
  }

  removeListeners() {
    this.onChange.disconnectAll();
  }

  disconnect() {
    this.observer.disconnect();
  }
}
